import { motion } from "framer-motion";
import RectangleIcon from "@mui/icons-material/Rectangle";
import EditLocationIcon from "@mui/icons-material/EditLocation";
import PaymentIcon from "@mui/icons-material/Payment";
import Widget from "./Widget";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import WineBarIcon from "@mui/icons-material/WineBar";

const HomePage = () => {
	const container = {
		show: {
			transition: {
				staggerChildren: 0.06,
			},
		},
	};

	const item = {
		hidden: { opacity: 0, y: 20 },
		show: { opacity: 1, y: 0 },
	};
	return (
		<div className="w-full">
			<motion.div
				className="flex flex-col md:flex-row sm:p-8 container"
				variants={container}
				initial="hidden"
				animate="show"
			>
				<div className="flex flex-1 flex-col min-w-0 pt-16">
					<div className="flex flex-col flex-wrap sm:flex sm:flex-row pb-32">
						<motion.div
							variants={item}
							className="widget flex w-full sm:w-1/3 p-16"
						>
							<Widget
								title="Your Orders"
								subTitle="Track, cancel"
								Icon={RectangleIcon}
								to="/orders"
							/>
						</motion.div>

						<motion.div
							variants={item}
							className="widget flex w-full sm:w-1/3 p-16"
						>
							<Widget
								title="Winery Events"
								subTitle=""
								Icon={RectangleIcon}
								to="/my-events"
							/>
						</motion.div>

						<motion.div
							variants={item}
							className="widget flex w-full sm:w-1/3 p-16"
						>
							<Widget
								title="Your Address"
								subTitle="Edit address for orders"
								Icon={EditLocationIcon}
								to="/address"
							/>
						</motion.div>

						<motion.div
							variants={item}
							className="widget flex w-full sm:w-1/3 p-16"
						>
							<Widget
								title="Payment options"
								subTitle="Edit or add payment methods"
								Icon={PaymentIcon}
								to="/payment/methods"
							/>
						</motion.div>
						<motion.div
							variants={item}
							className="widget flex w-full sm:w-1/3 p-16"
						>
							<Widget
								title="Subscription"
								// subTitle="Edit or add payment methods"
								Icon={SubscriptionsIcon}
								to="/subscriptions"
							/>
						</motion.div>
						<motion.div
							variants={item}
							className="widget flex w-full sm:w-1/3 p-16"
						>
							<Widget
								title="Wine club"
								// subTitle="Edit or add payment methods"
								Icon={WineBarIcon}
								to="/wine-clubs"
							/>
						</motion.div>
					</div>
				</div>
			</motion.div>
		</div>
	);
};

export default HomePage;
